
// document.addEventListener("DOMContentLoaded", function () {

//   const openBtn = document.querySelector(".open-quote-popup");
//   const popup = document.getElementById("quotePopup");
//   const closeBtn = document.querySelector(".close-popup");

//   if (openBtn) {
//     openBtn.addEventListener("click", function () {
//       popup.style.display = "flex";
//     });
//   }

//   if (closeBtn) {
//     closeBtn.addEventListener("click", function () {
//       popup.style.display = "none";
//     });
//   }

//   window.addEventListener("click", function (e) {
//     if (e.target === popup) {
//       popup.style.display = "none";
//     }
//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById("quotePopup");

  document.addEventListener("click", function (e) {

    // OPEN popup (for any button)
    if (e.target.closest(".open-quote-popup")) {
      popup.style.display = "flex";
          const btn = e.target.closest(".open-quote-popup");
    const productTitle = btn.getAttribute("product-title");
    document.getElementById("quote_pro_title").value = productTitle;
    }
    // CLOSE popup (button or outside click)
    if (
      e.target.classList.contains("close-popup") ||
      e.target === popup
    ) {
      popup.style.display = "none";
    }

  });

});